// CloudTalk click-to-call API client.
// Backend routes: server/src/route/cloudtalkRoute.js (mounted at /cloudtalk).

import { axiosInstance } from '../common';

const ENDPOINT_CALL = '/cloudtalk/call';
const ENDPOINT_HISTORY = '/cloudtalk/history';
const ENDPOINT_CALLER_IDS = '/cloudtalk/caller-ids';
const ENDPOINT_SYNC = '/cloudtalk/sync';

export const initiateCall = async ({ contact_id, customer_id, project_id, to_number, country_code, caller_id_number }) => {
    const res = await axiosInstance.post(ENDPOINT_CALL, {
        contact_id,
        customer_id,
        project_id,
        to_number,
        country_code,
        caller_id_number,
    });
    return res?.data ?? res;
};

export const getCallHistory = async ({ contact_id, customer_id, project_id, limit, page = 1, pageSize = 10 } = {}) => {
    const res = await axiosInstance.get(ENDPOINT_HISTORY, {
        params: { contact_id, customer_id, project_id, limit, page, pageSize },
    });
    // axios unwraps to the backend body { status, data, pagination }.
    const rows = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
    const pagination = res?.pagination || { total: rows.length, page, pageSize };
    return { rows, pagination };
};

export const updateCallNotes = async (id, notes, status = null, duration_sec = null) => {
    const payload = { notes };
    if (status) payload.status = status;
    if (typeof duration_sec === 'number') payload.duration_sec = duration_sec;
    const res = await axiosInstance.patch(`/cloudtalk/call-logs/${id}/notes`, payload);
    return res?.data ?? res;
};

export const getCallerIds = async (country_code) => {
    const res = await axiosInstance.get(ENDPOINT_CALLER_IDS, {
        params: { country_code },
    });
    return res?.data ?? res;
};

export const syncCalls = async ({ agent_id, date_from, date_to } = {}) => {
    const res = await axiosInstance.post(ENDPOINT_SYNC, null, {
        params: { agent_id, date_from, date_to },
    });
    return res?.data ?? res;
};

export const checkActiveCallStatus = async ({ to_number, agent_id, call_log_id, started_at } = {}) => {
    const res = await axiosInstance.get('/cloudtalk/active-call-status', {
        params: { to_number, agent_id, call_log_id, started_at },
    });
    return res?.data ?? res;
};

export const getCloudTalkAgents = async () => {
    const res = await axiosInstance.get('/cloudtalk/agents');
    return Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
};

export const getMyAgent = async () => {
    const res = await axiosInstance.get('/cloudtalk/my-agent');
    return res?.data ?? res ?? {};
};

